<script src="../app.routing.ts"></script>

<div class="" [class.hidden]="preLoader"
    style="width: 100%;text-align: center;height: 100%;position: fixed;padding-top: 40vh;z-index: 9999;background: rgba(255, 255, 255, 0.94);">
    <img class="animated infinite pulse" src="images_ext/logo1.png" style="width: 125px;">
</div>

<div class="menubar-hoverable header-fixed menubar-pin "
    style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
    <!-- header -->
    <!--  -->


    <!-- BEGIN BASE-->
    <div id="base">
        <div class="hide" id="load_new_admissions"></div>
        <!-- BEGIN OFFCANVAS LEFT -->
        <div class="offcanvas">
        </div>
        <!--end .offcanvas-->
        <!-- END OFFCANVAS LEFT -->

        <!-- BEGIN CONTENT-->
        <div id="content">
            <section>
                <div class="section-body">

                    <div class="whole-box2">

                        <div class="col-md-12 contents-div">
                            <div class="col-md-12 registered-name-div">
                                <span>Hello <span class="school-name">{{registeredName}}!</span></span>
                                <!-- <div class="logout-button">Logout</div> -->
                            </div>

                            <div class="col-md-12 cards-container">
                                <div class="col-md-3 cards">
                                    <div class="card-heading">
                                        <div>Total Schools</div>
                                        <div><img class="card-image" src="images/school-normal.svg"></div>
                                    </div>
                                    <div style="font-size: 30;font-weight: bold;">{{totalSchool}}</div>
                                </div>
                                <div class="col-md-3 cards">
                                    <div class="card-heading">
                                        <div>Active Schools</div>
                                        <div><img class="card-image" src="images/school-active.svg"></div>
                                    </div>
                                    <div style="font-size: 30;font-weight: bold;">{{totalActiveSchool}}</div>
                                </div>
                                <div class="col-md-3 cards">
                                    <div class="card-heading">
                                        <div>Inactive Schools</div>
                                        <div><img class="card-image" src="images/school-unactive.svg"></div>
                                    </div>
                                    <div style="font-size: 30;font-weight: bold;">{{totalInactiveSchool}}</div>
                                </div>
                                <div class="col-md-3 cards">
                                    <div class="card-heading">
                                        <div>Total Students</div>
                                        <div><img class="card-image" src="images/student-total.svg"></div>
                                    </div>
                                    <div style="font-size: 30;font-weight: bold;">{{totalStudent}}</div>
                                </div>
                            </div>

                            <div class="col-md-12 graph-cards-container">
                                <div class="col-md-6 graph-cards">
                                    <div class="graff-header">
                                        Fee Analytics
                                        <select style="float: right;" (change)="feesYearChange($event.target.value)">
                                            <option value="{{academicYear}}" selected disabled>{{academicYear}}</option>
                                            <option *ngFor="let academic of academicYearList" value="{{academic.year}}">
                                                {{academic.year}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="chart-container">
                                        <canvas id="feesGraff"></canvas>
                                    </div>
                                </div>

                                <div class="col-md-6 graph-cards">
                                    <div class="graff-header">
                                        Student Analytics
                                        <select style="float: right;" (change)="studentYearChange($event.target.value)">
                                            <option value="{{academicYear}}" selected disabled>{{academicYear}}</option>
                                            <option *ngFor="let academic of academicYearList" value="{{academic.year}}">
                                                {{academic.year}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="chart-container">
                                        <canvas id="studentGraff"></canvas>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12 graph-bottom-container">
                                <div class="graph-bottom">
                                    <div class="graff-bottom-header">
                                        School Analytics
                                        <select style="float: right;" (change)="schoolYearChange($event.target.value)">
                                            <option value="2000-2010">2000-2010</option>
                                            <option value="2010-2020">2010-2020</option>
                                            <option value="2020-2030" selected>2020-2030</option>
                                        </select>
                                    </div>
                                    <div class="chart-container">
                                        <canvas id="schoolGraff" width="720" height="210"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!--end .section-body -->
            </section>
        </div>
        <!--end #content-->
        <!-- END CONTENT -->

        <!-- Menubar -->
        <!--  -->

    </div>
    <!--end #base-->
    <!-- END BASE -->
</div>